class ShippingDateRange extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.fromDate = this.querySelector('#fromDate')
    this.toDate = this.querySelector('#toDate')

    /* Partie administrable */
    let dateDebut = 2,
      dateFin = 4,
      livraisonSamedi = "oui";
    /* Fin - Partie administrable */

    let fromDateTimestamp = new Date().getTime() + 24 * dateDebut * 3600 * 1000,
      fromDateDay = new Date(fromDateTimestamp).getDate(),
      fromDateMonth = new Date(fromDateTimestamp).getMonth() + 1,
      toDateTimestamp = new Date().getTime() + 24 * dateFin * 3600 * 1000,
      toDateDay = new Date(toDateTimestamp).getDate(),
      toDateMonth = new Date(toDateTimestamp).getMonth() + 1;

    fromDateMonth = (fromDateMonth < 9 ? '0' : '') + fromDateMonth;
    toDateMonth = (toDateMonth < 9 ? '0' : '') + toDateMonth;

    const checkIfWe = day => {
      if (new Date(fromDateTimestamp).getDay() === 6) {
        if (day !== 1) {
          fromDateDay = fromDateDay + 2;
          toDateDay = toDateDay + 2;
        }
      }
    }

    livraisonSamedi === "oui" ? checkIfWe(1) : checkIfWe(2);

    this.fromDate.innerHTML = `${fromDateDay}/${fromDateMonth}`;
    this.toDate.innerHTML = `${toDateDay}/${toDateMonth}`;

    const dgShippingDate = this.querySelector('.dg_shipping-date');

    if (dgShippingDate != null) {
      dgShippingDate.style.display = 'block';
    }
  }
}

customElements.define('shipping-date-range', ShippingDateRange);